import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import AttendanaceLayout from "../../components/AttendanceLayout/AttendanaceLayout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ExcelJS from "exceljs";
import { toast, ToastContainer } from "react-toastify";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";

function AttendanceTable() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const id = localStorage.getItem("mandalDetailsId");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [samparkEmployees, setSamparkEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("all");
  const [mandalName, setMandalName] = useState("");
  const [attendanceData, setAttendanceData] = useState({});
  const [toggleOrder, setToggleOrder] = useState([]);
  const [attendanceSummary, setAttendanceSummary] = useState({
    total: 0,
    present: 0,
    absent: 0,
  });

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "AttendanceWorker") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    setToggleOrder([]);
    fetchSamparkEmployees();
    fetchRecords();
  }, [selectedEmployee, id, selectedDate]);

  useEffect(() => {
    handleSearch();
  }, [search, data]);

  const handleEmployeeSelect = (event) => {
    setSelectedEmployee(event.target.value);
  };

  const fetchSamparkEmployees = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${apiURL}/SamparkEmploye/Get`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const employees = response.data.data.filter(
        (item) => Number(id) === item.mandalDetailsId,
      );
      setSamparkEmployees((prev) => {
        const uniqueEmployees = [...prev, ...employees].reduce((acc, emp) => {
          acc.set(emp.id, emp);
          return acc;
        }, new Map());
        return Array.from(uniqueEmployees.values());
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Error fetching employees");
    }
  };

  const fetchRecords = async () => {
    const token = localStorage.getItem("token");
    if (!id) {
      toast.error("Invalid ID");
      return;
    }
    setLoading(true);
    try {
      let url =
        selectedEmployee === "all"
          ? `${apiURL}/User/GetUserAttendence?mandalDetailsId=${id}&samparkEmployeId=&date=${selectedDate}`
          : `${apiURL}/User/GetUserAttendence?mandalDetailsId=${id}&samparkEmployeId=${selectedEmployee}&date=${selectedDate}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const fetchedData = response?.data?.data || [];
      let finalData = [];

      if (selectedEmployee === "all") {
        finalData = fetchedData.filter(
          (item) => item.isVisible === true || item.isVisible === null,
        );
      } else {
        finalData = fetchedData;
      }

      setData(finalData);
      setFilteredData(finalData);

      const total = finalData.length;
      const present = finalData.filter(
        (item) => item.attendenceStatus === true,
      ).length;
      const absent = total - present;
      setAttendanceSummary({ total, present, absent });
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  const handleSearch = () => {
    if (!search) {
      setFilteredData(data);
      return;
    }
    const lowercasedSearch = search.toLowerCase();
    const filtered = data.filter((row) => {
      const sequenceNo = `${row.sequenceNo}`;
      const fullName =
        `${row.firstName} ${row.lastName} ${row.surName}`.toLowerCase();
      const contactNumbers = [row.contactNo]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return (
        sequenceNo === lowercasedSearch ||
        fullName.includes(lowercasedSearch) ||
        contactNumbers === lowercasedSearch
      );
    });
    setFilteredData(filtered);
  };

  const toggleAttendance = async (haribhaktId) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token is missing!");
        return;
      }
      const config = {
        method: "post",
        url: `${apiURL}/UserAttendence/ToggleAttendence?haribhaktId=${haribhaktId}&mandalDetailsId=${id}&date=${selectedDate}`,
        headers: { Authorization: `Bearer ${token}` },
      };

      await axios.request(config);

      const currentItem = data.find((item) => item.id === haribhaktId);
      const isCurrentlyPresent = currentItem?.attendenceStatus;

      if (isCurrentlyPresent) {
        setToggleOrder((prev) => prev.filter((x) => x !== haribhaktId));
      } else {
        setToggleOrder((prev) => [
          haribhaktId,
          ...prev.filter((x) => x !== haribhaktId),
        ]);
      }

      fetchRecords();
    } catch (error) {
      console.error(
        "Error toggling attendance:",
        error.response?.data || error,
      );
    }
  };

  useEffect(() => {
    const fetchAttendanceForAll = async () => {
      let attendanceSummaryData = {};
      for (let haribhakt of data) {
        let config = {
          method: "get",
          url: `${apiURL}/UserAttendence/GetByList?haribhaktId=${haribhakt.id}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
        try {
          const response = await axios.request(config);
          if (response.data.status) {
            const records = response.data.data;
            let uniqueDates = {};
            let present = 0;
            records.forEach((record) => {
              if (!uniqueDates[record.date]) {
                uniqueDates[record.date] = record.attendenceStatus;
              }
            });
            let totalRecords = Object.keys(uniqueDates).length;
            Object.values(uniqueDates).forEach((status) => {
              if (status) present++;
            });
            attendanceSummaryData[haribhakt.id] = { totalRecords, present };
          }
        } catch (error) {
          console.error(
            `Error fetching attendance for Haribhakt ${haribhakt.id}:`,
            error,
          );
        }
      }
      setAttendanceData(attendanceSummaryData);
    };
    fetchAttendanceForAll();
  }, [data]);

  const exportToExcel = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        selectedEmployee === "all"
          ? `${apiURL}/User/GetUserAttendence?mandalDetailsId=${id}&samparkEmployeId=&date=${selectedDate}`
          : `${apiURL}/User/GetUserAttendence?mandalDetailsId=${id}&samparkEmployeId=${selectedEmployee}&date=${selectedDate}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    try {
      const response = await axios.request(config);
      if (response.data.status === false) {
        toast.error("No records found for the specified date.");
        return;
      }
      const attendanceData = response.data.data.map((item, index) => ({
        No: index + 1,
        Id: item.sequenceNo,
        Name: item.firstName + " " + item.lastName + " " + item.surName,
        MobileNo: item.contactNo,
        HouseNo: item.houseNo,
        Street: item.street,
        Address: item.address || "-",
        Attendance: item.attendenceStatus ? "P" : "A",
      }));
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Attendance");
      worksheet.columns = [
        { header: "No", key: "No", width: 5 },
        { header: "Id", key: "Id", width: 8 },
        { header: "Name", key: "Name", width: 25 },
        { header: "Mobile No", key: "MobileNo", width: 15 },
        { header: "House No", key: "HouseNo", width: 10 },
        { header: "Street", key: "Street", width: 20 },
        { header: "Address", key: "Address", width: 30 },
        { header: "Attendance", key: "Attendance", width: 10 },
      ];
      attendanceData.forEach((data) => {
        const row = worksheet.addRow(data);
        if (data.Attendance === "P") {
          row.getCell("Attendance").font = { color: { argb: "008000" } };
          row.getCell("Attendance").alignment = {
            horizontal: "center",
            vertical: "middle",
          };
        } else {
          row.getCell("Attendance").font = { color: { argb: "FF0000" } };
          row.getCell("Attendance").alignment = {
            horizontal: "center",
            vertical: "middle",
          };
        }
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const fileName = `Attendance_${selectedDate}.xlsx`;
      const link = document.createElement("a");
      link.href = URL.createObjectURL(new Blob([buffer]));
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error("Error exporting attendance data:", error);
      toast.error("No records found for the specified date.");
    }
  };

  const exportToPDF = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        selectedEmployee === "all"
          ? `${apiURL}/User/GetUserAttendence?mandalDetailsId=${id}&samparkEmployeId=&date=${selectedDate}`
          : `${apiURL}/User/GetUserAttendence?mandalDetailsId=${id}&samparkEmployeId=${selectedEmployee}&date=${selectedDate}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    try {
      const response = await axios.request(config);
      if (response.data.status === false) {
        toast.error("No records found for the specified date.");
        return;
      }
      const attendanceData = response.data.data.map((item, index) => [
        index + 1,
        item.sequenceNo || "-",
        `${item.firstName} ${item.lastName} ${item.surName}`.trim(),
        item.contactNo || "-",
        item.houseNo || "-",
        item.street || "-",
        item.address || "-",
        item.attendenceStatus ? "P" : "A",
      ]);
      const doc = new jsPDF({ orientation: "portrait", format: "a4" });
      const pageWidth = doc.internal.pageSize.width;
      const headerText = `Attendance Report (${selectedDate})`;
      const headerWidth = doc.getTextWidth(headerText);
      doc.setFontSize(14);
      doc.text(headerText, (pageWidth - headerWidth) / 2, 10);
      const headers = [
        "No",
        "Id",
        "Name",
        "Mobile No",
        "House No",
        "Street",
        "Address",
        "Attendance",
      ];
      autoTable(doc, {
        head: [headers],
        body: attendanceData,
        startY: 20,
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 15 },
          2: { cellWidth: 40 },
          3: { cellWidth: 25 },
          4: { cellWidth: 15 },
          5: { cellWidth: 30 },
          6: { cellWidth: 40 },
          7: { cellWidth: 15 },
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 10,
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
        },
        bodyStyles: { lineColor: [0, 0, 0], lineWidth: 0.2, fontSize: 8 },
        margin: { top: 25, left: 10, right: 10 },
      });
      doc.save(`Attendance_Report_${selectedDate}.pdf`);
    } catch (error) {
      console.error("Error exporting attendance data:", error);
      toast.error("Failed to generate PDF.");
    }
  };

  useEffect(() => {
    fetchMandalName();
  }, [id]);

  const fetchMandalName = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiURL}/MandalDetails/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    try {
      let response = await axios.request(config);
      const data = response.data.data;
      setMandalName(data.name + "(" + data.description + ")");
    } catch (error) {
      console.error(error?.response.data.status);
    }
  };

  const sortedData = [...filteredData].sort((a, b) => {
    const aIdx = toggleOrder.indexOf(a.id);
    const bIdx = toggleOrder.indexOf(b.id);
    if (aIdx === -1 && bIdx === -1) return 0;
    if (aIdx === -1) return 1;
    if (bIdx === -1) return -1;
    return aIdx - bIdx;
  });

  const columns = [
    {
      name: "ID",
      selector: (row) => row.sequenceNo,
      sortable: true,
      width: "65px",
      center: "true",
    },
    {
      name: "Actions",
      width: "100px",
      center: "true",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn mr-1"
            onClick={() => toggleAttendance(row.id)}
          >
            <span className={row.attendenceStatus ? "lightGreen" : "lightRed"}>
              {row.attendenceStatus ? "P" : "A"}
            </span>
          </button>
        </div>
      ),
    },
    {
      name: "Name(Total Sabha/Total Aattendance)",
      selector: (row) => {
        const attendance = attendanceData[row.id] || {
          totalRecords: 0,
          present: 0,
        };
        return (
          <div>
            {row.firstName} {row.lastName} {row.surName} &nbsp;
            <span style={{ color: "green", fontWeight: "bold" }}>
              ({attendance.present}
            </span>
            <span style={{ color: "blue", fontWeight: "bold" }}>
              /{attendance.totalRecords})
            </span>
          </div>
        );
      },
      sortable: true,
      width: "400px",
    },
    {
      name: "Mobile Number",
      selector: (row) => row.contactNo,
    },
    {
      name: "House No",
      selector: (row) => row.houseNo,
    },
    {
      name: "Street and Address",
      selector: (row) => row.street + ", " + row.address,
    },
  ];

  return (
    <AttendanaceLayout ac8="active" id={id}>
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h5>Mandal Attendance</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/attendance-worker-dashboard" state={{ id }}>
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item">Attendance List</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                    {/* Search with clear button */}
                    <div
                      className="bd-highlight mb-2 mb-md-0"
                      style={{ position: "relative" }}
                    >
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search"
                        title="Search within table"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ paddingRight: "36px", width: "100%" }}
                      />
                      {search && (
                        <button
                          type="button"
                          onClick={() => setSearch("")}
                          style={{
                            position: "absolute",
                            right: "8px",
                            top: "45%",
                            transform: "translateY(-50%)",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#dc3545",
                            fontSize: "24px",
                            lineHeight: 1,
                            padding: "0 2px",
                            fontWeight: "bold",
                          }}
                          aria-label="Clear search"
                        >
                          &times;
                        </button>
                      )}
                    </div>
                    <div className="d-flex align-items-center mb-2 mb-md-0">
                      <div className="d-flex align-items-center">
                        <label className="mr-2">Sampark:</label>
                        <select
                          className="form-control"
                          onChange={handleEmployeeSelect}
                          value={selectedEmployee}
                        >
                          <option value="all">All</option>
                          {samparkEmployees.map((emp) => (
                            <option key={emp.id} value={emp.id}>
                              {emp.firstName} {emp.lastName} {emp.surName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="bd-highlight"></div>
                    <div className="row d-flex flex-column flex-md-row align-items-center justify-content-center text-center">
                      <div className="d-flex">
                        <div className="bd-highlight mr-2 mb-2 mb-md-0 mr-md-2">
                          <input
                            type="date"
                            className="form-control"
                            title="Select a date"
                            placeholder="Select a date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                          />
                        </div>
                        <div className="bd-highlight mr-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={exportToExcel}
                          >
                            <i className="fas fa-file-export"></i> Excel
                          </button>
                        </div>
                        <div className="bd-highlight">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={exportToPDF}
                          >
                            <i className="fas fa-file-export"></i> PDF
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Attendance summary badges */}
                  <div
                    className="d-flex flex-wrap gap-2 mt-2"
                    style={{ gap: "8px" }}
                  >
                    <span
                      style={{
                        background: "#e9ecef",
                        color: "#495057",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "15px",
                        fontWeight: "700",
                      }}
                    >
                      Total: {attendanceSummary.total}
                    </span>
                    <span
                      style={{
                        background: "#d4edda",
                        color: "#155724",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "15px",
                        fontWeight: "700",
                      }}
                    >
                      Present: {attendanceSummary.present}
                    </span>
                    <span
                      style={{
                        background: "#f8d7da",
                        color: "#721c24",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "15px",
                        fontWeight: "700",
                      }}
                    >
                      Absent: {attendanceSummary.absent}
                    </span>
                  </div>
                </div>

                <div className="card-body text-center">
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={sortedData}
                      pagination
                      responsive
                      className="custom-table"
                      onChangePage={(page) => setCurrentPage(page)}
                      onChangeRowsPerPage={(newPerPage) => {
                        setRowsPerPage(newPerPage);
                        setCurrentPage(1);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </AttendanaceLayout>
  );
}

export default AttendanceTable;
